import { render, staticRenderFns } from "./barGroup.vue?vue&type=template&id=bd81573c&scoped=true&"
import script from "./barGroup.vue?vue&type=script&lang=js&"
export * from "./barGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd81573c",
  null
  
)

export default component.exports